<p-toast position="bottom-left">
</p-toast>
<div [class.twofactor-wrapper]="isLoginFlow" class="twofa-login">

  @if(isLoginFlow) {
    <div class="column__figure">

      <h2>Multi-Factor <br>
        Authentication</h2>
      <div class="figure__icon"><img src="assets/images/multifactor.svg" alt="Manage Your Account"></div>
      <p>Manage Your Account</p>
    </div>
  }

  <div class="column__content">
    @if(isLoginFlow) {
      <img src="assets/images/logo.svg" class="logo" alt="Flecx">
    }

    <h1>SMS verification</h1>
      <div class="form-field">
        <div class="pills-wrapper">
          <div class="pills pills--cover-profile">
            <div class="pills__content hand">
              @if(phoneNumber) {
                <i class="fa fa-phone"></i>
                <span class="tf-label pl-6">{{phoneNumber}}</span>
              }

              @if(!isLoginFlow && smsCount <= 0) {
                <button class="btn-send" (click)="sendCodeSMS()">Send Code</button>
              }
            </div>
          </div>
        </div>
      </div>

      @if(isSMSSent) {
        <p class="small-text mt-15">
          A text message has been sent to your phone. Please copy the code and paste below.
        </p>
      }

      <div class="form-field">
        @if(!isSMSSent) {
          <div class="tf-label">
            <label class="form__label">Verification Code</label>
          </div>
        }

        <input class="form__input" type="text" name="code" [(ngModel)]="code" [disabled]="!isSMSSent" [placeholder]="!isLoginFlow ? 'Enter Verification Code' : ''" required>
        @if(isError && !code) {
          <div class="alert error-msg">
              Code is required.
          </div>
        }
      </div>

      @if(isSMSSent && smsCount > 0 && smsCount <=3) {
        <div class="form__group">
          @if (timeLeft > 0) {
            <p class="small-text">You can resend the code in {{ displayTimeLeft }}.</p>
          } @else {
            <a class="dont-get-email hand" (click)="sendCodeSMS()">Didn't get the SMS? Send again.</a>
          }
        </div>
      }

      <div class="mt-15">
        <button (click)="verifyCode(code)" [disabled]="smsCount <= 0">Verify</button>
      </div>
      @if(verified == null){
      <div class="mt-15">
        Don't have access to your authentication device? <br> You can <a routerLink="/recovery-code-verification"> log in with
          a recovery code</a>.
      </div>
      }
      @if(isLoginFlow) {
        <div class="mt-10">
          <button class="secondary" (click)="onBack()">Back to Login</button>
        </div>
      }
  </div>
</div>
